import { createApp, h } from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Toast from "vue-toastification";
import { useToast } from "vue-toastification";
import format from 'date-fns/format';
import "vue-toastification/dist/index.css";
import 'tw-elements';
import './icons';

const toast = useToast();
InertiaProgress.init()

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - MyHeart` : 'MyHeart',
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) });

    app.config.globalProperties.$toast = toast;

    app.config.globalProperties.$filters = {
      formatDate(value, type) {
        if(typeof(type) != "string") {
          type = 'dd/MM/yyyy';
        }
        if(typeof(value) != "object") {
          value = new Date(value);
        }
        return format(value, type);
      },
      formatDateTime(value, type) {
        if(typeof(type) != "string") {
          type = 'dd/MM/yyyy HH:mm';
        }
        if(typeof(value) != "object") {
          value = new Date(value);
        }
        return format(value, type);
      },
    }
    
    app.component('font-awesome-icon', FontAwesomeIcon)
    .use(plugin)
    .use(Toast)
    .mount(el);
  },
})